<div class="card card-custom">
    <div class="d-flex justify-content-between">
        <div class="card-header d-flex align-items-center flex-wrap">
            <h3 class="card-title align-items-start flex-column">
                <span class="font-weight-bolder text-dark">
                    {{"WidgetPlantGraph" | localize}}
                </span>
            </h3>
        </div>
        <div class="d-flex">
            <div class="d-flex align-items-center">
                <label class="col d-block mb-0" for="Supplier_Name">{{ "PlantSupplierName" | localize }}</label>
                <div class="col-sm-12">
                    <mat-form-field>
                        <mat-select [formControl]="supplierFormCtrl"
                                    [multiple]="true"
                                    #supplierSelector
                                    (selectionChange)="selectedSupplier($event)">
                            <mat-option *ngFor="let name of suppliers"
                                        [value]="name.supplierName">
                                        {{name.supplierName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex align-items-center">
                <label class="col d-block mb-0" for="SerialNumber_Manager">{{ "SerialNumber" | localize }}</label>
                <div class="col-sm-12">
                    <mat-form-field>
                        <mat-select [formControl]="serialNumberFormCtrl"
                                    [multiple]="true"
                                    #serialNumberSelector
                                    (selectionChange)="selectedSerialNumber($event)">
                            <mat-option *ngFor="let serialNumber of serialNumbers"
                                        [value]="serialNumber.serialNumber">
                                        {{serialNumber.serialNumber }} 
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="d-flex align-items-center">
                <label class="col d-block mb-0" for="Location_Manager">{{ "Location" | localize }}</label>
                <div class="col-sm-12">
                    <mat-form-field>
                        <mat-select [formControl]="locationFormCtrl"
                                    [multiple]="true"
                                    #locationSelector
                                    (selectionChange)="selectedLocation($event)">
                            <mat-option *ngFor="let location of locations"
                                        [value]="location.locationName">
                                        {{location.locationName }} 
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body" [perfectScrollbar]>
        <div class="row">
            <div class="col" style="max-height: 200px">
                <ngx-charts-bar-vertical-stacked [results]="chartData" [xAxis]="showXAxis" [scheme]="scheme">
                    <ng-template #tooltipTemplate let-model="model">
                        <span>{{model.name}}</span>
                        <br />
                        <span>{{model.value}}</span>
                    </ng-template>
                </ngx-charts-bar-vertical-stacked>
            </div>
        </div>
    </div>
</div>